import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { API } from 'api';
import { BroadcastifyFeed } from 'features/broadcastify/broadcastify.types';

export type UseBroadcastifyFeedsProps = {
  lat: number;
  lng: number;
};

type UseBroadcastifyFeeds = Omit<
  UseQueryResult<BroadcastifyFeed[], Error>,
  'data'
> & {
  broadcastifyFeeds: BroadcastifyFeed[];
};

const fetchBroadcastifyFeeds = async (
  input: UseBroadcastifyFeedsProps,
): Promise<BroadcastifyFeed[]> => {
  const { lat, lng } = input;
  const urlParams = new URLSearchParams({
    lat: lat.toString(),
    lng: lng.toString(),
  });
  const result = await API.get<BroadcastifyFeed[]>(
    `broadcastify/?${urlParams.toString()}`,
  );
  return result.data;
};

export const useBroadcastifyFeeds = (
  props: UseBroadcastifyFeedsProps,
): UseBroadcastifyFeeds => {
  const { lat, lng } = props;

  const { data = [], ...results } = useQuery<BroadcastifyFeed[]>({
    queryKey: ['broadcastifyFeeds', lat, lng],
    queryFn: () => fetchBroadcastifyFeeds(props),
    staleTime: 1000 * 60, // 1 minute
  });

  return {
    ...results,
    broadcastifyFeeds: data,
  };
};
